'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUndoDecreaseElementCount = exports.createUndoIncreaseElementCount = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Constants


var _milanoteLodash = require('../../milanoteLodash');

var _elementConstants = require('../../../../common/elements/elementConstants');

var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);

var _reactRouterRedux = require('react-router-redux');

var _selectionConstants = require('../../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

var _elementCountConstants = require('../../../user/elementCount/elementCountConstants');

var ELEMENT_COUNT_ACTION_TYPES = _interopRequireWildcard(_elementCountConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Reverse location & from
var getSingleMoveUndoDetails = function getSingleMoveUndoDetails(state, _ref) {
    var id = _ref.id,
        location = _ref.location,
        from = _ref.from;
    return {
        id: id,
        location: _extends({}, from),
        from: _extends({}, location)
    };
};

var createUndoMoveAction = function createUndoMoveAction(state, action) {
    return _extends({
        type: action.type
    }, getSingleMoveUndoDetails(state, action), {
        sync: action.sync
    });
};

var createUndoMultiMoveAction = function createUndoMultiMoveAction(state, action) {
    return {
        type: action.type,
        moves: action.moves.map(function (move) {
            return getSingleMoveUndoDetails(state, move);
        }),
        sync: action.sync
    };
};

var getSingleUpdateUndoDetails = function getSingleUpdateUndoDetails(state, _ref2) {
    var changes = _ref2.changes,
        id = _ref2.id;
    return {
        id: id,
        changes: (0, _milanoteLodash.objectIntersection)(changes, state.getIn(['elements', id, 'content']).toJS())
    };
};

var createUndoUpdateAction = function createUndoUpdateAction(state, action) {
    return {
        type: action.type,
        updates: action.updates.map(function (update) {
            return getSingleUpdateUndoDetails(state, update);
        }),
        sync: action.sync
    };
};

var createUndoMoveAndUpdateAction = function createUndoMoveAndUpdateAction(state, action) {
    return _extends({}, createUndoMoveAction(state, action), getSingleUpdateUndoDetails(state, action));
};

var createUndoCreateAction = function createUndoCreateAction(state, action) {
    return {
        type: ELEMENT_ACTION_TYPES.ELEMENT_DELETE,
        id: action.id,
        elementType: action.elementType,
        // Need to add this to ensure the action is synced with the server
        location: {
            parentId: action.location.parentId
        },
        sync: action.sync
    };
};

var createUndoRouteChange = function createUndoRouteChange(state, action) {
    return {
        type: _reactRouterRedux.LOCATION_CHANGE,
        payload: _extends({}, state.get('routing').locationBeforeTransitions, {
            action: 'POP'
        })
    };
};

var createUndoSelectAction = function createUndoSelectAction(state, action) {
    return {
        type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED,
        ids: action.ids,
        sync: action.sync
    };
};

var createUndoIncreaseElementCount = exports.createUndoIncreaseElementCount = function createUndoIncreaseElementCount(state, action) {
    return {
        type: ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE,
        counts: action.counts
    };
};

var createUndoDecreaseElementCount = exports.createUndoDecreaseElementCount = function createUndoDecreaseElementCount(state, action) {
    return {
        type: ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE,
        counts: action.counts
    };
};

var buildReverseAction = function buildReverseAction(state, action) {
    switch (action.type) {
        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_AND_UPDATE:
            return createUndoMoveAndUpdateAction(state, action);
        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_MULTI:
            return createUndoMultiMoveAction(state, action);
        case ELEMENT_ACTION_TYPES.ELEMENT_UPDATE:
            return createUndoUpdateAction(state, action);
        case ELEMENT_ACTION_TYPES.ELEMENT_CREATE:
            return createUndoCreateAction(state, action);
        case _reactRouterRedux.LOCATION_CHANGE:
            return createUndoRouteChange(state, action);
        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
            return createUndoSelectAction(state, action);
        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE:
            return createUndoIncreaseElementCount(state, action);
        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE:
            return createUndoDecreaseElementCount(state, action);
        default:
            throw Error('UNDO: Unknown action type, ' + action.type);
    }
};

exports.default = function (state, action) {
    return _extends({}, buildReverseAction(state, action), {
        isUndo: true,
        transactionId: action.transactionId
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/middleware/createUndoAction.js
// module id = 2145
// module chunks = 0